/** @jsx jsx */
import { jsx } from "theme-ui"
import React from "react"
import { useTranslation } from "react-i18next"
import Img from "gatsby-image"
import { getFluidGatsbyImage } from "gatsby-source-sanity"
import { getFile } from "@sanity/asset-utils"

import Iframely from "../../../molecules/Iframely"
import AnimateInView from "../../../atoms/AnimateInView"
import config from "../../../../../../config"

const { NODE_ENV, CONTEXT: NETLIFY_ENV = NODE_ENV } = process.env
const isNetlifyProduction = NETLIFY_ENV === "production"

const sanityConfig = {
  projectId: config.sanityProjectId,
  dataset: isNetlifyProduction ? "production" : "staging",
}

export const Image = props => {
  const { t } = useTranslation()

  return (
    <React.Fragment>
      {props.node.asset && (
        <Img
          fluid={getFluidGatsbyImage(
            props.node.asset.id,
            { maxWidth: 1280 },
            sanityConfig
          )}
          alt={props.node.alt}
          sx={{
            maxHeight: "70vh",
            gridColumn:
              props.node.style === "centered" ? ["-1 / 1", "-4 / 4"] : "-1 / 1",
            mt: 6,
            mb: props.node.attribution ? 0 : 6,
            ...(props.node.style === "centered"
              ? {
                  mx: [theme => -theme.space.pageWrap.small, 0],
                }
              : {
                  mx: [
                    theme => -theme.space.pageWrap.small,
                    theme => -theme.space.pageWrap.large,
                  ],
                }),
          }}
        />
      )}
      {props.node.attribution && (
        <div
          sx={{
            gridColumn: ["1 / -1", "-4 / 4"],
            fontSize: 0,
            textAlign: "left",
            fontWeight: "bold",
            textTransform: "uppercase",
            mb: 6,
          }}
        >
          {t("commons.photoCredit")}
          <span
            sx={{
              ml: 2,
              fontSize: 1,
              fontWeight: "normal",
              fontStyle: "italic",
              color: "#6d6d6d",
              textTransform: "none",
            }}
          >
            {props.node.attribution}
          </span>
        </div>
      )}
    </React.Fragment>
  )
}

export const Embed = props => {
  return (
    <AnimateInView
      y="0"
      sx={{
        my: 6,
        mx: [theme => -theme.space.pageWrap.small, 0],
      }}
    >
      <Iframely url={props.node.url} />
    </AnimateInView>
  )
}

export const Link = ({ mark, children }) => {
  const { blank, href } = mark

  return blank ? (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ) : (
    <a href={href}>{children}</a>
  )
}

export const EmailLink = ({ mark, children }) => {
  const { href } = mark
  const emailLink = "mailto:" + href

  return <a href={emailLink}>{children}</a>
}

export const FileLink = ({ mark, children }) => {
  const file = getFile(mark.file, sanityConfig)
  return <a href={file.asset.url}>{children}</a>
}

export const Container = props => {
  return <React.Fragment>{props.children}</React.Fragment>
}
